import { BirdviewCommunicationKind } from '../DashboardBirdview.constants'

import ChatIcon from '../../../icons/chats.svg'
import EmailIcon from '../../../icons/email.svg'

export const BIRDVIEW_COMMUNICATION_ROW_KIND = {
  [BirdviewCommunicationKind.Chat]: {
    Icon: ChatIcon,
    emptyTitleKey: 'DashboardBirdview.NoChatTitleKey',
  },
  [BirdviewCommunicationKind.Email]: {
    Icon: EmailIcon,
    emptyTitleKey: 'DashboardBirdview.NoEmailSubjectKey',
  },
}
